import { css } from 'emotion';

const s = css`
  margin: 70px auto;
  text-align: center;
  width: 250px;
`;

export default s;
